import React, { } from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import { Box, Button } from '@mui/material';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { usePublicacaoDiarioOficialController } from './context/publicacao-diario-oficial-controller';
import { usePublicacaoDiarioOficialState } from './context/publicacao-diario-oficial-context';
import { PublicacaoDiarioOficialForm } from './publicacao-diario-oficial-form';
import { useBeforeUnload } from 'react-router-dom';
import OfficialDiaryAppService from '../../../application/platform/official-daily/official-daily-app-service';
import { PublicacaoDiarioOficialPreview } from './publicacao-diario-oficial-preview';

export const PublicacaoDiarioOficial = () => {
    const { activeStep, completed , previewPublicationRequest} = usePublicacaoDiarioOficialState();
    const { isLastStep, steps, handleBack, handleNext, confirmPublication } = usePublicacaoDiarioOficialController();

    
    useBeforeUnload(() => {
        OfficialDiaryAppService.releasePublication(previewPublicationRequest.clientId).then(response => console.log(response));
    }
    );
    const renderContent = () => {
        if (activeStep === 0) {
            return <PublicacaoDiarioOficialForm></PublicacaoDiarioOficialForm>
        } else {
            return <PublicacaoDiarioOficialPreview></PublicacaoDiarioOficialPreview>
        } 
    };
    
    return (
        <React.Fragment>
            <Grid item xs={12} md={12} lg={12}>
                <Paper
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column'
                    }} elevation={3}
                >
                    <Grid item sx={{ mb: 5 }} xs={12} md={12} lg={12}>
                        <Stepper nonLinear activeStep={activeStep}>
                            {steps.map((label, index) => (
                                <Step key={label} completed={completed[index]}>
                                    <StepButton color="inherit">
                                        {label}
                                    </StepButton>
                                </Step>
                            ))}
                        </Stepper>
                    </Grid>
                    {renderContent()}
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>

                        <Button
                            variant="contained"
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                            startIcon={<ArrowCircleLeftIcon />}
                        >
                            Anterior
                        </Button>
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Button
                            variant="contained"
                            onClick={() => { isLastStep() ? confirmPublication() : handleNext() }} sx={{ mr: 1 }} endIcon={isLastStep() ? <CheckCircleIcon /> : <ArrowCircleRightIcon />}>
                            {isLastStep()
                                ? 'Finalizar'
                                : 'Próximo'}

                        </Button>

                    </Box>
                </Paper>
            </Grid>
        </React.Fragment>
    );
}